import direDawnIcon from "@assets/diredawn_icon.png";
import {Link} from "react-router";
import SearchView from "@/search/SearchView.tsx";
import PlayerViewMenu from "@/player/PlayerViewMenu.tsx";
import {ReactElement} from "react";
import {AxeIcon, BookText, Castle, ImageIcon, MapIcon, SquareUserIcon, Swords, WandSparkles} from "lucide-react";
import UserMenu from "@/auth/UserMenu.tsx";
import {Button} from "@/components/ui/button.tsx";
import {DropdownMenuTrigger} from "@radix-ui/react-dropdown-menu";
import {DropdownMenu, DropdownMenuContent, DropdownMenuItem} from "@/components/ui/dropdown-menu.tsx";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import {useActiveEncounter} from "@/encounter/ActiveEncounterHooks.ts";

const components: { title: string; path: string; icon: ReactElement }[] = [
    {title: "Zauber", path: "spells", icon: <WandSparkles className="size-4 text-info"/>},
    {title: "Gegenstände", path: "items", icon: <AxeIcon className="size-4 text-warning"/>},
    {title: "Charaktere", path: "characters", icon: <SquareUserIcon className="size-4 text-info"/>},
    {title: "Dungeons", path: "dungeons", icon: <Castle className="size-4 text-success"/>},
    {title: "Encounter", path: "encounters", icon: <Swords className="size-4 text-destructive"/>},
    {title: "Szenen", path: "scenes", icon: <ImageIcon className="size-4 text-warning"/>},
]

function Header() {
    const {campaign, campaignPath} = useCampaign();
    const {activeEncounter} = useActiveEncounter();
    const encounterPath = activeEncounter
        ? campaignPath(`encounters/${activeEncounter.id}/map`)
        : campaignPath("encounters");

    return (
        <header
            className="grid min-h-12 grid-cols-3 items-center border-b border-border bg-surface/90 px-2 shadow-lg shadow-black/10 backdrop-blur-xl">
            <div className="flex h-full items-center gap-3">
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button type="button" variant="ghost"
                                className="h-auto gap-2 rounded-none p-0 px-2 text-foreground hover:bg-transparent hover:text-foreground data-[state=open]:bg-transparent focus-visible:outline-hidden"
                                aria-label="DireDawn Navigation">
                            <img src={direDawnIcon} className="size-7" alt="Diredawn"/>
                            <span className="text-base font-semibold tracking-wide">DireDawn</span>
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="min-w-50">
                        <ul className="grid">
                            {components.map(element => (
                                <DropdownMenuItem key={element.title} asChild>
                                    <Link to={campaignPath(element.path)} title={element.title}>
                                        <div className="flex flex-row items-center gap-2 font-medium">
                                            {element.icon}
                                            {element.title}
                                        </div>
                                    </Link>
                                </DropdownMenuItem>
                            ))}
                        </ul>
                        <DropdownMenuItem asChild>
                            <Link to="/" title="Kampagne wechseln">
                                <div className="flex flex-row items-center gap-2 font-medium">
                                    <BookText className="size-4 text-secondary"/>Kampagne wechseln
                                </div>
                            </Link>
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
                <span className="h-6 border-l border-border" aria-hidden="true"/>
                <Link to={campaignPath()}
                      className="max-w-52 truncate text-sm font-semibold text-foreground transition-colors hover:text-primary"
                      title={campaign.title}>{campaign.title}</Link>
                <Button asChild
                        type="button"
                        variant="ghost" className="h-10 rounded-lg font-medium">
                    <Link to={encounterPath}>
                        <MapIcon/> Karte</Link>
                </Button>
            </div>

            <div className="justify-self-center">
                <SearchView/>
            </div>
            <div className="flex h-full items-center justify-self-end">
                <PlayerViewMenu/>
                <UserMenu/>
            </div>
        </header>
    )
}

export default Header
